<template>
    <div class="valorar-pedido-wrapper">
        <overlay :show="showAll" />
        <div :class="{ 'overlay-item': showAll }" class="valorar-pedido">
            <div class="valorar-pedido-btn-action" @click="toggleAll">
                Valora este pedido
                <div class="pedido-id-icon-positioner">
                    <down-icon v-show="!showAll"></down-icon>
                    <up-icon v-show="showAll"></up-icon>
                </div>
            </div>
            <div class="formulario" v-show="showAll">
                <template v-if="!isRecogidaBabyplant">
                    <div class="question">
                        ¿Estás satisfecho con el tiempo de espera hasta que has
                        recibido las plantas?
                    </div>
                    <div class="star-rating-pos">
                        <div @click="showAll = true">
                            <star-rating
                                :star-size="starSizeNumber"
                                :show-rating="false"
                                v-bind:min-rating="0"
                                v-model="rateService"
                            ></star-rating>
                        </div>
                    </div>
                    <hr />
                    <div class="question">
                        ¿Has recibido el embalaje con algún daño que resaltar?
                    </div>
                    <textarea
                        v-model="observations"
                        aria-label="escribir comentario"
                        rows="3"
                        class="comentario-textarea form-control"
                        placeholder="Escribir comentario"
                    ></textarea>
                    <hr />
                </template>
                <div class="question">
                    ¿Estás contento con la calidad de la planta recibida?
                </div>
                <div class="star-rating-pos rate-plant">
                    <star-rating
                        :star-size="starSizeNumber"
                        :show-rating="false"
                        v-bind:min-rating="0"
                        v-model="ratePlant"
                    ></star-rating>
                </div>
                <hr />
                <div class="question">
                    ¿Recomendarías Babyplant Store a un amigo?
                </div>
                <div class="would-recommend-btn-pos">
                    <div
                        class="recommend-button"
                        @click="wouldRecommendAction(true)"
                        :class="{ 'recommend-selected': wouldRecommended }"
                    >
                        SI
                    </div>
                    <div
                        class="recommend-button no"
                        @click="wouldRecommendAction(false)"
                        :class="{ 'recommend-selected': wouldntRecommended }"
                    >
                        NO
                    </div>
                </div>
                <div
                    class="valorar-pedido-submit-btn"
                    @click="submitValoracion"
                >
                    Enviar
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StarRating from "vue-star-rating";
import Overlay from "../../Overlay.vue";
import DownIcon from "./DownIcon";
import UpIcon from "./UpIcon";
export default {
    name: "ValorarPedidoBtn",
    components: { UpIcon, DownIcon, StarRating, Overlay },
    props: {
        valoracionData: {
            required: true
        },
        isRecogidaBabyplant: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            starSizeNumber: 40,
            rateService: 0,
            ratePlant: 3,
            wouldRecommend: null,
            observations: "",
            voted: false,
            submitting: false,
            showAll: false
        };
    },
    computed: {
        wouldRecommended() {
            return this.wouldRecommend === "si";
        },
        wouldntRecommended() {
            return this.wouldRecommend === "no";
        },
        pedidoId() {
            return this.valoracionData.pedido_id;
        },
        valoracionId() {
            return this.valoracionData.id;
        }
    },
    watch: {
        valoracionData() {
            this.loadData();
        }
    },
    methods: {
        toggleAll() {
            this.showAll = !this.showAll;
        },
        submitValoracion() {
            if (this.submitting || this.voted) {
                return;
            }

            this.submitting = true;

            let observations = this.observations;
            let rateService = this.rateService;
            if (this.isRecogidaBabyplant) {
                observations = "RECOGIDA_EN_TIENDA";
                rateService = 5;
            }

            axios
                .post(this.route("account.store.valoracion.entrega"), {
                    id: this.valoracionId,
                    observations,
                    pedido_id: this.pedidoId,
                    rate_plant: this.ratePlant,
                    rateService,
                    would_recommend: this.wouldRecommend
                })
                .then(res => {
                    this.voted = true;
                    Vue.toasted.show(
                        "Valoración enviada. Tu opinión nos ayudará a mejorar para ofrecer el mejor servicio.",
                        {
                            type: "success",
                            duration: 3000
                        }
                    );
                    this.$emit("voted");
                })
                .catch(err => {
                    if (err.response.status === 422) {
                        Vue.toasted.show(
                            "Asegurate de contestar todos los campos",
                            {
                                type: "error",
                                duration: 3000
                            }
                        );
                    } else {
                        Vue.toasted.show(
                            "Error al intentar guardar la encuesta. Inténtalo más tarde.",
                            {
                                type: "error",
                                duration: 3000
                            }
                        );
                    }
                })
                .finally(() => {
                    this.submitting = false;
                });
        },
        wouldRecommendAction(val) {
            if (val) {
                this.wouldRecommend = "si";
            } else {
                this.wouldRecommend = "no";
            }
        },
        loadData() {
            this.rateService = this.valoracionData.rate_service;
            this.ratePlant = this.valoracionData.rate_plant;
            this.voted = this.valoracionData.voted;
            this.observations = this.valoracionData.observations;
            let wouldRecommend = this.valoracionData.would_recommend;
            if (wouldRecommend !== null) {
                if (wouldRecommend) {
                    wouldRecommend = "si";
                } else {
                    wouldRecommend = "no";
                }
            }
            this.wouldRecommend = wouldRecommend;
        }
    },
    created() {
        this.loadData();
    }
};
</script>

<style scoped>
.valorar-pedido {
    display: block;
    width: 100%;
    border: 3px solid #007e87;
    position: relative;
    background-color: #fff;
}

.valorar-pedido-btn-action {
    cursor: pointer;
    text-decoration: none;
    position: relative;
    text-align: center;
    font-size: 0.9rem;
    font-weight: 600;
    line-height: 1.6;
    text-transform: none;
    vertical-align: middle;
    color: #007e87;
    transition: none;
    padding: 0.375rem 0.75rem;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.pedido-id-icon-positioner {
    position: absolute;
    right: 5%;
    top: 0;
    width: 1.4em;
    height: 100%;
    display: flex;
    align-items: center;
}

.pedido-btn img {
    width: 100%;
}

.formulario {
    position: absolute;
    width: calc(100% + 6px); /* Para arreglar los bordes */
    left: -3px; /* Para arreglar los bordes */
    background-color: #fff;
    padding: 0.375rem;
    border: 3px solid #007e87;
    border-top: 0;
    z-index: 100;
}

.star-rating-pos {
    display: flex;
    justify-content: center;
    padding-bottom: 1rem;
    padding-top: 0.625rem;
}

.star-rating-pos.rate-plant {
    padding-top: 0;
}

.question {
    text-align: center;
    font-weight: bold;
}

.comentario-textarea {
    background-color: #f3f2f2;
    border-radius: 0;
    color: #818282;
    border-color: #818282;
}

.would-recommend-btn-pos {
    display: flex;
    justify-content: center;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
}

.recommend-button {
    padding: 0.5rem;
    width: 40%;
}

.recommend-button.no {
    margin-left: 1rem;
}

.recommend-button.recommend-selected {
    background-color: #007e87;
}

.valorar-pedido-submit-btn {
    background-color: #007e87;
    color: white;
    cursor: pointer;
    font-weight: bold;
    text-align: center;
    padding: 0.5rem;
}

.valorar-pedido-submit-btn:hover {
    background-color: #007e87;
}

.recommend-button {
    background-color: #9c9b9b;
    cursor: pointer !important;
    font-weight: bold;
    text-align: center;
    color: #fff;
}

hr {
    border-top: 1px solid rgba(0, 0, 0, 0.3);
    width: 80%;
}

@media screen and (max-width: 575px) {
    .valorar-pedido {
        border-width: 1px;
    }

    .formulario {
        width: 100%;
        left: 0;
        border: 0;
        position: relative;
    }
}
</style>
